import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import { APP_ROUTES, PLAN_V2_URL, generatePlanningRoute } from 'app/common/constants';
import { AuthUserService } from 'app/core/services/auth-user.service';
import {SIDEBAR} from '../common/constants';

export interface RouteInfo {
  path: string;
  title: string;
  icon: string;
  class: string;
  iconPath: string,
  hide:boolean,
  isExternal?: boolean;
}

export const ROUTES: RouteInfo[] = [
  { path: generatePlanningRoute(APP_ROUTES.PLANNING.IMPORT), title: 'Import',
    icon: 'fa-upload', class: '', iconPath: '', hide: false },

  { path: generatePlanningRoute(APP_ROUTES.PLANNING.PO_SELECTION), title: 'CREATE INSPECTIONS',
    icon: 'fa-list-check', class: '', iconPath: '', hide: !SIDEBAR['show-po-selection'] },

  { path: generatePlanningRoute(APP_ROUTES.PLANNING.PRODUCT), title: 'Product',
    icon: 'fa-upload', class: '', iconPath: '../../assets/img/measure.png', hide: false },

  { path: generatePlanningRoute(APP_ROUTES.PLANNING.MANAGE_INSPECTIONS), title: 'Manage Inspections',
    icon: 'fa-solid fa-layer-group', class: '', iconPath: '', hide: false },

  { path: generatePlanningRoute(APP_ROUTES.PLANNING.PACKAGING), title: 'Packaging',
    icon: 'fa-check-square', class: '', iconPath: '../../assets/icons/box.svg', hide: !SIDEBAR['show-packaging'] },

  { path: generatePlanningRoute(APP_ROUTES.PLANNING.DOWNLOADS), title: 'Downloads',
    icon: 'fa-book', class: '', iconPath: '', hide: !SIDEBAR['show-downloads'].show },

  { path: generatePlanningRoute(APP_ROUTES.PLANNING.INSPECTION_DETAIL), title: 'AQL Inspection Report',
    icon: 'fa-universal-access', class: '', iconPath: '../../assets/icons/t-shirt.svg', hide: true },

  { path: generatePlanningRoute(APP_ROUTES.PLANNING.SKIPPED_INSPECTIONS), title: 'SKIPPED INSPECTIONS',
    icon: 'fa-fast-forward', class: '', iconPath: '', hide: !SIDEBAR['show-skip-inspections'] },

  // External Booking Requests (Auto Planner)
  {
    // Keep base URL here so role permissions using PLAN_V2_URL still match
    path: PLAN_V2_URL,
    title: 'Booking Requests',
    icon: 'fa-calendar',
    class: '',
    iconPath: '',
    hide: false,
    isExternal: true,
  },
];

@Component({
  moduleId: module.id,
  selector: 'sidebar-cmp',
  templateUrl: 'sidebar.component.html', styleUrls: ['style.css'],
})
export class SidebarComponent implements OnInit {
  public menuItems: any[];
  @Output() toggleSidebar = new EventEmitter<void>();

  constructor(private authService: AuthUserService) {
  }

  ngOnInit() {
    this.authService.onAuthChange().subscribe(() => {

      const allowedPaths = this.authService.AccessPages;
      this.menuItems = ROUTES.filter(menuItem => {
        return !menuItem.hide && allowedPaths.has(menuItem.path);
      });
    });
  }
}
